import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import WhatsAppButton from "@/components/WhatsAppButton";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import SocialProofBar from "@/components/SocialProofBar";
import MethodologySection from "@/components/services/MethodologySection";
import AIAllySection from "@/components/AIAllySection";
import HubSection from "@/components/HubSection";
import BrandsSection from "@/components/BrandsSection";
import HomeTeamSection from "@/components/HomeTeamSection";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";

const GlobalPresenceSection = lazy(() => import("@/components/GlobalPresenceSection"));

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <ServicesSection />
        <SocialProofBar />
        <MethodologySection />
        <AIAllySection />
        <HubSection />
        <BrandsSection />
        <HomeTeamSection />
        <Suspense fallback={<div className="min-h-[400px] bg-foreground" />}>
          <GlobalPresenceSection />
        </Suspense>
        <CTASection />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Index;
